import React from "react";
import Table from "../../../../../components/shared/Table";
import { formatTimestamp } from "../../../../../utils";

const PaymentsExpandable = ({ data }) => {
  if (!data?.Payments?.length) {
    return <div className="p-3 text-gray-500">No payments available.</div>;
  }

  return (
    <div className="p-3">
      <h4 className="font-semibold text-lg mb-2 text-[#1e40af]">
        Payment History
      </h4>
      <ul className="list-disc pl-5 space-y-1 text-sm">
        {data.Payments.map((payment, index) => (
          <li key={index}>
            Amount: {payment.amount?.toLocaleString()}{" "}
            <span>
              <strong>Date:</strong> {formatTimestamp(payment.createdAt)}
            </span>{" "}
            <span>
              <strong>Payment Status:</strong> {payment.payment_status}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const AffiliateDetailsTable = ({ affiliateCodeData, affiliateCode }) => {
  const affiliateReferrals = [
    { name: "Email", selector: (row) => row.email },
    { name: "Username", selector: (row) => row.user_name },
    { name: "Total Paid", selector: (row) => row.totalPaid },
  ];
  return (
    <div>
      <h2 className="text-center font-black pb-3 text-[#001f68]">
        Refferals for {affiliateCode.toUpperCase()}
      </h2>
      <Table
        // customStyles={customStyles}
        title="User Orders"
        column={affiliateReferrals}
        data={affiliateCodeData}
        expandableRows={true}
        expandableRowsComponent={PaymentsExpandable}
      />
    </div>
  );
};

export default AffiliateDetailsTable;
